import styles from './index.module.scss'
import { Input, Button, Card } from 'antd';
import LoginModal from '../../compoents/loginModal';

export default function LoginPage () {
    return (
        <div className={styles.LoginPage}>
            <div className={styles.LeftContent}>
                <span>PSAI Master</span>
                <span>最懂您品牌调性的AI商拍工作室</span>
                <div></div>
            </div>
            <div className={styles.LoginContent}>
                <LoginModal />
            </div>
        </div>
    )
}